import { connect } from 'react-redux'
import { actions } from '../../store/adminEvents'
import { generateListCallbacks } from '../../store/helpers/listActionsHelpers'

function mapStateToProps(state) {
  return {
    adminEvents: state.adminEvents,
    authUser: state.auth,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...generateListCallbacks(dispatch, actions),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)